import { useEffect, useState } from "react"

/**
 * useDebouncedValue
 *
 * Returns a value that lags `delayMs` behind every update. Useful for
 * search inputs that should fire side-effects only when typing pauses.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState<T>(value)

  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), delayMs)
    return () => window.clearTimeout(handle)
  }, [value, delayMs])

  return debounced
}
